/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const TravelBenefit = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M11.6999 29.05C9.91991 29.05 8.20991 28.12 7.26991 26.5L4.18991 21.23C3.82991 20.63 3.75991 19.89 3.99991 19.22C4.23991 18.55 4.75991 18.02 5.43991 17.78L6.36991 17.44C7.21991 17.14 8.10991 17.24 8.82991 17.69L11.6699 19.42L14.8399 18.27L10.2799 12.53C9.79991 11.92 9.64991 11.11 9.85991 10.38C10.0699 9.65001 10.6299 9.06001 11.3399 8.80001L13.6899 7.94001C14.5399 7.62001 15.5099 7.69001 16.3399 8.11001L27.2099 13.77L33.8599 11.35C36.2999 10.47 38.9899 11.73 39.8699 14.15C40.7499 16.58 39.4899 19.27 37.0699 20.15L13.4699 28.74C12.8899 28.95 12.2999 29.05 11.7099 29.05H11.6999ZM7.04991 20.3L9.80991 25.02C10.3499 25.94 11.4599 26.34 12.4599 25.97L36.0699 17.38C36.9699 17.05 37.4399 16.05 37.1099 15.14C36.7899 14.24 35.7799 13.78 34.8699 14.1L27.6199 16.74C27.2299 16.88 26.7999 16.85 26.4399 16.66L14.9999 10.71C14.9099 10.67 14.7999 10.66 14.7099 10.69L13.0599 11.29L18.4099 18.03C18.6999 18.4 18.7999 18.89 18.6699 19.34C18.5399 19.8 18.1999 20.16 17.7599 20.32L12.0099 22.41C11.5899 22.56 11.1199 22.52 10.7399 22.28L7.28991 20.18L7.03991 20.28L7.04991 20.3Z"
      fill="#000"
    />
    <path
      d="M5.72006 33.7598C4.75006 33.7598 3.97007 34.6098 4.11007 35.6198C4.22007 36.4398 5.01007 37.0098 5.84007 37.0098H38.1501C38.9801 37.0098 39.7701 36.4398 39.8801 35.6198C40.0201 34.6198 39.2501 33.7598 38.2701 33.7598H5.72006Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default TravelBenefit
